import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";

import {AlertService, AuthenticationService, UploadService} from '../../_services/index';
import {LoginHelper} from '../../helpers';
import {ListMessageComponent} from "../listMessage";

/*
    Tenant,
    User
} from '../../_models/index';
*/

const now = new Date();

@Component({
    standalone: false,
    selector: 'upload-compliance-area-component',
    templateUrl: 'upload.compliance.area.component.html',
    styleUrls: ['./upload.compliance.area.component.css'],
})

export class UploadComplianceAreaComponent implements OnInit {
    loading = false;
    complianceAreaName: string;
    complianceAreaFile: File;

    constructor(
      public dialogRef: MatDialogRef<UploadComplianceAreaComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public route: ActivatedRoute,
      public uploadService: UploadService,
      public alertService: AlertService,
      public authenticationService: AuthenticationService,
      public dialog: MatDialog,) {
    }

    ngOnInit() {
        let tenantName = LoginHelper.getTenantName();
        if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return;
        }
        if (this.data && this.data.complianceArea)
        {
          this.complianceAreaName = this.data.complianceArea.name;
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }

    uploadComplianceArea(event) {

        if (this.complianceAreaName == null){
            this.alertService.error('You should fill Compliance Area Nmae.', true);
            return;
        }

        this.loading = true;

        this.alertService.clear();

        let attachments = event.target.files;
        if (attachments.length > 0) {
            let file:File = attachments[0];

            this.uploadService.uploadControlItems(file, this.complianceAreaName/*, this.data.complianceArea.complianceAreaId*/).subscribe(
            (res) => {
                    this.alertService.success('The Compliance Area was uploaded.', true);
              console.log(res);
              let config: MatDialogConfig = {
                panelClass: 'custom-overlay-pane-class',
                width: 'auto',
                height: '90%',
                data: {
                  items: res,

                  title: "Import report"
                }
              };
              this.dialog.open(ListMessageComponent, config);

                    this.loading = false;

                    this.onClose();
                },
                error => {
                    this.loading = false;
                    const message = "An error occurred while updating tenant.";
                    this.alertService.error(message);
                });
        }
    }
}
